import { render } from "./PortfolioGallery.vue?vue&type=template&id=f202b790&scoped=true&ts=true"
import script from "./PortfolioGallery.ts?vue&type=script&lang=ts&external"
export * from "./PortfolioGallery.ts?vue&type=script&lang=ts&external"

import "./PortfolioGallery.vue?vue&type=style&index=0&id=f202b790&scoped=true&lang=scss"

import exportComponent from "../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-f202b790"]])

export default __exports__